import React, { useState, useEffect } from 'react'
import { Alert, Button, ButtonGroup, Card, Col, Form, Row, Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import CustomNavbar from '../../../components/CustomNavbar';
import CustomTable from '../../../components/CustomTable';
import messages from '../../../redux/messages';
import SidebarConfig from '../../../components/SidebarConfig';
import { getFuncFormations, 
         saveFuncFormations, 
         editFuncFormations, 
         deleteFuncFormations } from '../../../redux/func_formacion/actions';
import CustomPagint from '../../../components/CustomPagint';

const FuncFormation = props => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  //Redux
  const dispatch = useDispatch();
  const data = useSelector(store => store.funcFormation.Formations);
  const dataLenght = useSelector(store => store.funcFormation.FormationLength);
  const pages = Math.ceil(dataLenght / limit);
  const loading = useSelector(store => store.funcFormation.loader);
  const saveLoading = useSelector(store => store.funcFormation.saveLoader);

  const columns = [
    {
      Header: 'Código',
      accessor: 'codigo'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div 
        className="btn-group" 
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
            <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  // Métodos
  const getAFuncFormations = (offs = offset, lim = limit, filt = filter) => dispatch(getFuncFormations({
    offset: offs,
    limit: lim,
    filter: filt
  }, parseInt(props.match.params.type)));

  useEffect(() => { getAFuncFormations() }, [props.match.params.type]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  }

  const onSearch = e => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAFuncFormations(oOffset, limit, e.target.filter.value);
  }

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = {
      codigo: e.target.codigo.value,
      descripcion: e.target.desc.value,
      documento: null
    };

    if(!edit){
      dispatch(saveFuncFormations(req, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    }else{
      dispatch(editFuncFormations(req, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }
  }

  const seeAll = () => {
    const oSearch = '';
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAFuncFormations(oOffset, limit, oSearch);
  }

  const onDelete = (id, index) => {
    if(window.confirm(messages.preguntaEliminar)){
      dispatch(deleteFuncFormations(id, index, parseInt(props.match.params.type)));
    }
  }

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">Funcional formación</h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                  id="filter"
                  name="filter"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle">
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Button 
                      variant="light" 
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}><i className="material-icons">add</i></Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length > 0 ? (
              <> 
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
                <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={dataLenght}
                pages={pages}
                pagFunc={getAFuncFormations} />
              </>
            ): (
              <Alert
                className="my-4" 
                variant="info">
                Aún formaciones, comienza a agregar algunas
              </Alert>
            )
          }
        </div>
      </div>
      <Modal 
        show={showModal}
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar formación' : 'Crear formación'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Código</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="codigo"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.codigo : null}
                  pattern="[A-Za-z0-9]+"
                  placeholder="Código"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Descripción</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="desc"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.descripcion : null}
                  pattern="[A-Za-z0-9]+"
                  placeholder="Descripción"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"  
              variant="secondary" 
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveLoading}  
              variant="primary" 
              type="submit">
                {
                  saveLoading ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default FuncFormation
